// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"553becf0","160":"9a2e83e1","208":"5fb7cec0","293":"1c1ee6b4","516":"7b54cb79","519":"897d1653","917":"8bce74f9","946":"52eb8c8b"}[chunkId] + ".chunk.js";
};